
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOrUpdateRaffleEntry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOrUpdateRaffleEntryAttributes"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originDomain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrUpdateRaffleEntry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"raffleEntryAttributes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attributes"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raffleEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"netAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"canShowTaxLines"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"taxAdjustments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"taxAdjustment"},"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"originKeyResponse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"originDomain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originDomain"}}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodsResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastAdyenPaymentResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"variant"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"variantRaffleEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userAddress"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"userAddress"},"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":838}};
    doc.loc.source = {"body":"#import '@/api/gql/_fragments/TaxAdjustment/taxAdjustment.gql'\n#import '@/api/gql/_fragments/UserAddress/userAddress.gql'\n#import '@/api/gql/_fragments/Variant/variantRaffleEntry.gql'\n\nmutation createOrUpdateRaffleEntry(\n  $attributes: CreateOrUpdateRaffleEntryAttributes!\n  $originDomain: String!\n) {\n  createOrUpdateRaffleEntry(raffleEntryAttributes: $attributes) {\n    raffleEntry {\n      id\n      state\n      email\n      order {\n       netAmount\n       canShowTaxLines\n       taxAdjustments {\n        ...taxAdjustment\n      }\n     }\n      originKeyResponse(originDomain: $originDomain)\n      paymentMethodsResponse\n      lastAdyenPaymentResponse\n      errors\n      variant {\n        ...variantRaffleEntry\n      }\n      shippingAddress {\n        ...userAddress\n      }\n      billingAddress {\n        ...userAddress\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/api/gql/_fragments/TaxAdjustment/taxAdjustment.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/api/gql/_fragments/UserAddress/userAddress.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/api/gql/_fragments/Variant/variantRaffleEntry.gql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["createOrUpdateRaffleEntry"] = oneQuery(doc, "createOrUpdateRaffleEntry");
        
